module.exports = __webpack_public_path__ + "static/media/bang.0efd4370.svg";